import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import ContentHeader from "../../components/MyContent/ContentHeader";
import EmptyStateCard from "../../components/MyContent/EmptyStateCard";
import ContentList from "../../components/MyContent/ContentList";
import LoadingState from "../../components/Common/LoadingState";
import { useMyContentData } from "../../hooks/useMyContentData";

const MyContentIndex = () => {
    const { t } = useTranslation();
    const { items, isEmpty, isLoading, openCreate, handleSelect } = useMyContentData();

    return (
        <Layout activeLabel="My content">
            <div>
                <ContentHeader
                    title={t("MY_CONTENT_TITLE")}
                    subtitle={t("MY_CONTENT_SUBTITLE")}
                    actionLabel={t("MY_CONTENT_NEW_CONTENT")}
                    onAction={openCreate}
                    showIcon
                />

                {isLoading ? (
                    <LoadingState message={t("MY_CONTENT_LOADING")} />
                ) : (
                    <>
                        {!isLoading && isEmpty && <EmptyStateCard onUpload={openCreate} />}
                        {!isEmpty && (
                            <ContentList
                                items={items}
                                onSelect={handleSelect}
                            />
                        )}
                    </>
                )}
            </div>
        </Layout>
    );
};

export default MyContentIndex;
